import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { usePromoModalContextStore } from "@faire/deprecated-retailer-visitor-shared/stores/ui/PromoModalContextStore";

import { isInBlockedPath } from "./isInBlockedPath";

export const useCanDisplayPromoModal = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const [{ hasUserClosedModal }] = usePromoModalContextStore([
    "hasUserClosedModal",
  ]);
  const blockedPath = isInBlockedPath();

  return !blockedPath && !hasUserClosedModal && isLoggedInRetailer;
};
